import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Statement, BigQuote, CTA } from "../components/Statement";
import { Showcase } from "../components/Showcase";
import { Gallery } from "../components/Gallery";
import { PoemQuote } from "../components/Quote";
import { Stats } from "../components/Stats";
import { Services } from "../components/Services";
import { BeforeAfter } from "../components/BeforeAfter";
import { Process } from "../components/Process";
import { Booking } from "../components/Booking";
import { Testimonials } from "../components/Testimonials";
import { FAQ } from "../components/FAQ";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Statement />
      <Showcase />
      <Services />
      <Stats />
      <BeforeAfter />
      <Process />
      <Gallery />
      <BigQuote />
      <Booking />
      <Testimonials />
      <FAQ />
      <PoemQuote />
      <CTA />
    </main>
  );
}
